import type {UseFormReturn} from 'react-hook-form';
import {useWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import DateRangeSelect from '@/components/date-range-select/DateRangeSelect';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {ExportFormValues} from '../../utils/exportFormInputs';
import type {DateRangeOptions} from '../../utils/exportOptions';

const DateRangeOptionsFields = <TOptions extends DateRangeOptions>({
  form,
}: ExportOptionsFieldsProps<TOptions>) => {
  const {t} = useTranslation();
  // UseFormReturn is invariant, so a parent form with wider options needs this cast
  const {control, setValue} = form as unknown as UseFormReturn<
    ExportFormValues<DateRangeOptions>
  >;
  const [startDate, endDate] = useWatch({
    control,
    name: ['options.startDate', 'options.endDate'],
  });

  return (
    <FormField
      control={control}
      name="options.startDate"
      render={() => (
        <FormItem>
          <FormLabel>{t('Date range')}</FormLabel>
          <FormControl>
            <div className="flex">
              <DateRangeSelect
                value={{startDate, endDate}}
                onChange={range => {
                  setValue('options.startDate', range.startDate);
                  setValue('options.endDate', range.endDate, {
                    shouldValidate: true,
                  });
                }}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DateRangeOptionsFields;
